<template>
  <el-button type="text" center></el-button>
</template>

<script>
import VueEvent from "../../api/eventBus"
    export default {
        data(){
            return{
                data:'删除'
            }
        },
        mounted(){
            VueEvent.$off("num")
            VueEvent.$on('num',function(data){
                if(data == 1){
                    const h = this.$createElement;
                    this.$msgbox({
                    title: '提示消息',
                    message: h('p', null, [
                        h('span', null, '你确定删除吗？'),
                        // h('i', { style: 'color: teal' }, )
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '执行中...';
                        setTimeout(() => {
                            done();
                            setTimeout(() => {
                            instance.confirmButtonLoading = false;
                            }, 300);
                        }, 1000);
                        } else {
                        done();
                        }
                    }
                    }).then(action => {
                        VueEvent.$emit('tab','2')
                        VueEvent.$off('ling')
                        VueEvent.$on('ling',function(data){
                            if(data == '0'){
                                this.$message({
                                    message: '删除成功'
                                });
                            } else if(data == '1'){
                                this.$message({
                                    message: '权限不足'
                                });     
                            }

                        })

                    });
                }
            })
        },
        methods: {
            open() {

            }
        }
    }
</script>

<style lang="less" scoped>
.el-button{
    text-align: center;
}
</style>
